export const BUBBLE_DESIGN = ['standard', 'expanded_bubble'];
export const WIDGET_DESIGN = ['standard', 'flat'];
export const DARK_MODE = ['light', 'auto', 'dark'];
export const LAUNCHER_STYLES = ['bubble', 'pill'];
export const LAUNCHER_POSITIONS = [
  'bottom_right',
  'bottom_left',
  'middle_right',
  'middle_left',
];
export const DEFAULT_LAUNCHER_POSITION = 'bottom_right';
export const DEFAULT_PILL_LABEL = 'chat';
export const CALLING_NUDGES_LABEL = 'calling-nudge';
export const MISSED_CALLS_LABEL = 'missed-call';
